import { Styles } from "../../../../types/common";

const styles: Styles = {
  wrapper: {
    "& .go_to_home__label": {
      fontSize: "18px",
      color: "#035C67",
      fontWeight: "700",
      textDecoration: "underline",
      cursor: "pointer",
      marginTop: "24px",
      display: "flex",
      alignItems: "center",
    },
  },
};

export default styles;
